import { useLazyGetMaintenanceDataQuery } from '@/store/api/maintenanceApi';
import { RootState } from '@/store/store';
import { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useActiveAssetsType } from '../../shared/useActiveAssetsType';
import { useParams } from 'react-router-dom';
import { useQueryNavigation } from '../../shared';
import { FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { format } from 'date-fns';
import { DIAGNOSTICS_REGULAR_DATE_FORMAT } from '@/const';

export const useFetchMaintenanceData = ({ assetId }: { assetId: string }) => {
  const { isMobileAsset } = useActiveAssetsType();

  const { currentParams } = useQueryNavigation();
  const { siteId } = useParams();
  //video evidence are avaliable only from 4th of Apr 2024 onwards
  const isAssetStudio = currentParams[FILTER_PARAMS.ASSET_STUDIO];

  const [fetchMaintenanceData, { data: maintenanceData, isLoading, isFetching }] = useLazyGetMaintenanceDataQuery();
  const { dateRange: studioDateRange } = useSelector((state: RootState) => state.assetsStudio);
  const { dateRange: previewDateRange } = useSelector((state: RootState) => state.assetsPreview);

  const { from, to } = isAssetStudio ? studioDateRange : previewDateRange;

  const getMaintenanceData = useCallback(() => {
    const params = {
      site_id: siteId,
      assetId: assetId,
      fromDate: format(new Date(from), DIAGNOSTICS_REGULAR_DATE_FORMAT),
      toDate: format(new Date(to), DIAGNOSTICS_REGULAR_DATE_FORMAT),
      assetCategory: isMobileAsset ? 'mobile' : 'fixed',
    };

    const missingItems: string[] = [];
    Object.keys(params).forEach((key) => {
      if (!params[key as keyof typeof params]) missingItems.push(key);
    });

    if (missingItems.length > 0) {
      return;
    }

    fetchMaintenanceData(params, true);
  }, [from, to, assetId, siteId, isMobileAsset, fetchMaintenanceData]);

  useEffect(() => {
    getMaintenanceData();
    ``;
  }, [getMaintenanceData, from, to]);

  return { maintenanceData, isLoadingMaintenanceData: isLoading || isFetching };
};
